<template>
  <svg width="38" height="44" viewBox="0 0 38 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.9398 37.3515C32.0381 35.177 38 27.7848 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 27.7848 5.96187 35.1771 14.0602 37.3515L18.9999 44L23.9398 37.3515Z" fill="#231F20"/>
    <path d="M28.25 19.5C28.25 24.9197 24.0746 29.25 19 29.25C13.9254 29.25 9.75 24.9197 9.75 19.5C9.75 14.0803 13.9254 9.75 19 9.75C24.0746 9.75 28.25 14.0803 28.25 19.5Z" stroke="white" stroke-width="1.5"/>
    <path d="M15 19H17V21H15V19Z" fill="white"/>
    <path d="M21 19H23V21H21V19Z" fill="white"/>
    <path d="M15 23.5C15 23.5 16.3333 25 19 25C21.6667 25 23 23.5 23 23.5" stroke="white" stroke-width="1.5"/>
    <path d="M10 23C8.34315 23 7 21.6569 7 20C7 18.3431 8.34315 17 10 17" stroke="white" stroke-width="1.5"/>
    <path d="M28 23C29.6569 23 31 21.6569 31 20C31 18.3431 29.6569 17 28 17" stroke="white" stroke-width="1.5"/>
    <path d="M17 8.53968L19 9.5L22 6" stroke="white" stroke-width="1.5"/>
  </svg>
</template>

<script>
export default {
  name: 'PanoramaIconKid'
}
</script>

<style scoped>

</style>
